<template>
  <div class="invite-friend">
    <top-banner></top-banner>
    <invite-main></invite-main>
    <activity-footer></activity-footer>
    <div class="btn-invite" @click="copyInviteLink">
      {{ $t('btnInvite') }}
    </div>
  </div>
</template>

<script>
import TopBanner from '@/components/activity/invite/TopBanner'
import InviteMain from '@/components/activity/invite/InviteMain'
import ActivityFooter from '@/components/activity/ActivityFooter'

export default {
  i18n: {
    messages: {
      en: {
        btnInvite: 'Invite Friends',
        shareTip: 'Share referal link',
        copyFaiedTip: 'The browser does not support automatic copying',
      },
      id: {
        btnInvite: 'Undang Teman',
        shareTip: 'Bagikan link referal',
        copyFaiedTip: 'The browser does not support automatic copying',
      },
    },
  },
  components: {
    TopBanner,
    InviteMain,
    ActivityFooter,
  },
  data() {
    return {
      inviteCode: '',
    }
  },
  computed: {
    loggedin() {
      return this.$store.getters.loggedin
    },
    inviteLink() {
      return `${location.protocol}//${location.host}/activity/landing/MGM?inviteCode=${this.inviteCode}`
    },
  },
  async mounted() {
    if (this.loggedin) {
      await this.getInviteCode()
      if (this.fromRouteName === 'Login') {
        this.copyInviteLink()
      }
    }
  },
  methods: {
    async getInviteCode() {
      try {
        const response = await this.$http.get('/invitation/invite-code')
        this.inviteCode = response.data.data || ''
      } catch (error) {
        console.log(error)
      }
    },
    async copyInviteLink() {
      console.log('copy excuted...')
      if (!this.loggedin) {
        this.$router.push({ name: 'Login' })
        return
      }
      try {
        console.log('invite link: ', this.inviteLink)
        await this.$copyText(this.inviteLink)
        this.$toast.info(this.$t('shareTip'))
      } catch (error) {
        if (error.text) {
          this.$toast.info(this.$t('shareTip'))
        } else {
          this.$toast.failed(this.$t('copyFaiedTip'))
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name) {
        vm.fromRouteName = from.name
      }
    })
  },
}
</script>

<style scoped lang="stylus">
.invite-friend {

}

.btn-invite {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 0;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #3c3b43;
  line-height: 28px;
  background: linear-gradient(180deg, rgba(255, 224, 74, 1) 0%, rgba(205, 170, 0, 1) 100%);
  box-shadow: 0px 1px 11px 0px rgba(248, 16, 16, 0.5);
}
</style>
